import * as Factory from 'factory.ts'
import faker from 'faker'

import type { Components } from '@webapp/api/integrations/client'

const SyncLocalEntityMetadataStub =
  Factory.Sync.makeFactory<Components.Schemas.LocalEntityMetadata>({
    description: Factory.each(() => faker.random.word()),
  })

const syncResponseStubLocalEntityMetadata = SyncLocalEntityMetadataStub.build()

export const SyncLogResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.SyncLogResponse>({
    id: Factory.each(() => faker.random.uuid()),
    status: 'CREATED',
    message: Factory.each(() => faker.random.words(5)),
    created_at: Factory.each(() => faker.date.recent(1).toISOString()),
    local_entity: 'urn:integration:local-entity:bill',
    local_entity_ref: Factory.each(() => faker.random.number().toString()),
    root_local_entity_metadata: syncResponseStubLocalEntityMetadata,
  })

const syncResponseStubMostRecentLog = SyncLogResponseStub.build()

export const SyncResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.SyncResponse>({
    id: Factory.each(() => faker.random.uuid()),
    integration_id: Factory.each(() => faker.random.uuid()),
    status: 'CREATED',
    local_entity: 'urn:integration:local-entity:bill',
    local_entity_ref: Factory.each(() => faker.random.number().toString()),
    local_entity_metadata: syncResponseStubLocalEntityMetadata,
    type: 'PUSH',
    created_at: Factory.each(() => faker.date.recent(1).toISOString()),
    logs: [syncResponseStubMostRecentLog],
    most_recent_log: syncResponseStubMostRecentLog,
  })
